import { AuthenticationType } from './authenticationSettings';

export namespace AuthenticationSettingsUtil {
  export function authenticationTypeToString(type: string) {
    switch (type) {
      case AuthenticationType.code:
        return 'Code';
      case AuthenticationType.none:
        return 'None';
    }

    return type;
  }
}
